import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPackageDelivery1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPackageDelivery1"><Path d="M21 3H3V21H13V19H5V5H8V10H16V5H19V10H21V3Z" fill="currentColor"/><Path d="M21.0706 13.4144C19.5085 11.8523 16.9759 11.8523 15.4138 13.4144C13.8517 14.9765 13.8517 17.5091 15.4138 19.0712L18.2422 21.8996L21.0706 19.0712C22.6327 17.5091 22.6327 14.9765 21.0706 13.4144Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPackageDelivery1;
